









































































































































import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ApexCharts from "vue-apexcharts";
import moment from "moment";
import CompanyAPI from "@/services/companies";
import { QueryParams } from "@/models/general";
import Company from "@/models/company";
import { UserModule } from "@/store/user";
import ReportsAPI from "@/services/reports";
import { CampaignReportData } from "@/models/CampaignReport";

@Component({ components: { ApexCharts } })
export default class ClientCampaignsPerformance extends Vue {
  @Prop({ default: null }) inputCompany!: Company | null;
  data_prints: number[] = [];
  data_clicks: number[] = [];
  data_ctr: number[] = [];
  data_categories: string[] = [];
  companies: Company[] = [];
  company: string | null = null;

  created(): void {
    this.getData();
  }

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  get companyName(): string {
    if (this.inputCompany === null) {
      const company = this.companies.find((c) => c.id === this.company);
      return company ? company?.name : "";
    } else {
      return this.inputCompany.name;
    }
  }

  get globalClicks(): number {
    return this.data_clicks.reduce((partial, c) => partial + c, 0);
  }

  get globalPrints(): number {
    return this.data_prints.reduce((partial, c) => partial + c, 0);
  }

  get globalCtr(): number {
    return (this.globalClicks / this.globalPrints) * 100;
  }

  get series(): any {
    return [
      {
        name: this.$t("reports.campaign.prints"),
        type: "area",
        data: this.data_prints,
      },
      {
        name: this.$t("reports.campaign.clicks"),
        type: "area",
        data: this.data_clicks,
      },
      {
        name: "CTR",
        type: "area",
        data: this.data_ctr,
      },
    ];
  }

  get options(): any {
    return {
      title: {
        text: this.$t("reports.campaign.click_print_summary"),
      },
      xaxis: {
        title: { text: this.$t("reports.campaign.year_month") },
        categories: this.data_categories,
      },
      yaxis: [
        {
          title: { text: this.$t("reports.campaign.print_amount") },
          labels: {
            formatter: function (value: number) {
              return Math.trunc(value).toLocaleString();
            },
          },
        },
        {
          opposite: true,
          title: { text: this.$t("reports.campaign.click_amount") },
          labels: {
            formatter: function (value: number) {
              return Math.trunc(value).toLocaleString();
            },
          },
        },
        {
          opposite: true,
          title: { text: "CTR" },
          labels: {
            formatter: function (value: number) {
              return value.toFixed(2).toLocaleString();
            },
          },
        },
      ],
      stroke: {
        curve: "smooth",
      },
    };
  }

  async getData(): Promise<void> {
    LayoutModule.showLoader();

    if (this.inputCompany === null) {
      await this.getCompanies();
    } else {
      this.company = this.inputCompany.id as string;
    }
    LayoutModule.hideLoader();
  }

  async getCompanies(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await CompanyAPI.getCompanies(params);

      this.companies = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  @Watch("company", { deep: true })
  async getPerformanceReport(): Promise<void> {
    const token = this.$route.query.token
      ? (this.$route.query.token as string)
      : "";
    this.resetData();

    if (this.company !== null) {
      LayoutModule.showLoader();
      try {
        // const r =
        //   this.inputCompany === null
        //     ? await ReportsAPI.clientCampaignsPerformance(
        //         this.company as string
        //       )
        //     : await ReportsAPI.publicClientCampaignsPerformance(
        //         this.company as string,
        //         token
        //       );
        let r;

        if (this.inputCompany === null) {
          r = await ReportsAPI.clientCampaignsPerformance(
            this.company as string
          );
        } else {
          r =
            UserModule.currentUser.id !== ""
              ? await ReportsAPI.clientCampaignsPerformance(
                  this.company as string
                )
              : await ReportsAPI.publicClientCampaignsPerformance(
                  this.company as string,
                  token
                );
        }

        this.groupData(r);
      } catch (e) {
        console.log(e);
      }
      LayoutModule.hideLoader();
    }
  }

  groupData(r: CampaignReportData): void {
    r.data.forEach((d) => {
      const category = `${d.year}-${d.month}`;
      this.data_categories.indexOf(category) === -1
        ? this.data_categories.push(category)
        : null;
    });

    this.data_categories.forEach((c) => {
      let prints = 0;
      let clicks = 0;
      let ctr = 0;

      r.data.forEach((d) => {
        const category = `${d.year}-${d.month}`;
        if (category === c) {
          prints += d.prints;
          clicks += d.clicks;
        }
      });
      ctr = (clicks / prints) * 100;
      this.data_prints.push(prints);
      this.data_clicks.push(clicks);
      this.data_ctr.push(ctr);
    });
  }

  resetData(): void {
    this.data_prints = [];
    this.data_clicks = [];
    this.data_ctr = [];
    this.data_categories = [];
  }
}
